export default __webpack_public_path__ + "static/media/frg--indoor-pool.06d657b8.png";